<template>
  <section
    class="main-layout"
    :class="{ 'has-aside': hasAside, 'hide-aside': hasAside && !showAside }"
  >
    <section
      class="main-layout__main"
      :style="{ padding: Number(padding) ? `${padding}px` : padding }"
    >
      <slot></slot>
    </section>
    <aside v-if="hasAside" class="main-layout__aside">
      <div
        v-if="hasAside"
        class="main-layout__aside-switch"
        @click="toggleAside"
      >
        <i v-if="!showAside" class="el-icon-caret-left"></i>
        <i v-if="showAside" class="el-icon-caret-right"></i>
      </div>
      <div class="main-layout__aside-wrapper">
        <slot name="aside"></slot>
      </div>
    </aside>
  </section>
</template>

<script>
export default {
  name: 'MainLayout',
  components: {},
  data() {
    return {
      showAside: true,
    };
  },
  props: {
    padding: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    hasAside() {
      return !!this.$slots.aside;
    },
  },
  methods: {
    toggleAside() {
      this.showAside = !this.showAside;
    },
  },
};
</script>
